import * as logger from '@owl-nest/logger'

export function safePush(...[event, options]: Parameters<NonNullable<typeof window.plausible>>): void {
  const plausible = window.plausible
  if (plausible === undefined) {
    logger.warn('[shadow:plausible] plausible was not initialized')
    return fakePush(event, options)
  }
  return purePush(plausible, event, options)
}

export function fakePush(...[_, options]: Parameters<NonNullable<typeof window.plausible>>): void {
  const callback = options?.callback
  setTimeout(() => {
    if (callback) {
      callback()
    }
  }, 0)
}

function purePush(
  plausible: NonNullable<typeof window.plausible>,
  ...[event, options]: Parameters<NonNullable<typeof window.plausible>>
): void {
  const callback = options?.callback
  setTimeout(() => {
    if (callback) {
      callback()
    }
  }, 0)
  plausible(event, { props: options?.props })
}
